import { useQueryState, parseAsStringLiteral } from 'nuqs';

export const useTabQueryParam = <T extends string>(key: string, defaultTab: T, tabs: T[]) => {
  const parser = parseAsStringLiteral(tabs).withDefault(defaultTab);

  return useQueryState<T>(key, parser);
};
